import { render, staticRenderFns } from "./PhysicianPopup.vue?vue&type=template&id=4d2c377f&scoped=true&"
import script from "./PhysicianPopup.vue?vue&type=script&lang=js&"
export * from "./PhysicianPopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d2c377f",
  null
  
)

export default component.exports